"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  padding: 0.9em 1.2em;\n  text-decoration: none;\n  -webkit-font-smoothing: antialiased;\n  -webkit-touch-callout: none;\n  user-select: none;\n  cursor: pointer;\n  outline: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 500;\n  color: ", ";\n  transition: all 0.2s linear;\n\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n    background-color: ", ";\n  }\n  &.active {\n    background-color: none !important;\n    box-shadow: inset 0 -4px 0 ", ";\n    text-decoration: none;\n    color: ", ";\n  }\n  &:hover.active,\n  &:focus.active {\n    background-color: none !important;\n    box-shadow: inset 0 -4px 0 ", ";\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _default = _styledComponents["default"].a(_templateObject(), function (props) {
  return props.theme.navBarLink;
}, function (props) {
  return props.theme.navBarLink;
}, function (props) {
  return props.theme.navBarLinkHoverBack;
}, function (props) {
  return props.theme.navBarLinkActiveHoverBack;
}, function (props) {
  return props.theme.navBarLink;
}, function (props) {
  return props.theme.navBarLinkActiveHoverBack;
}, function (props) {
  return props.theme.navBarLink;
});

exports["default"] = _default;